<template>
    <div class="add-class-wrapper">
        <TitleBaseBox :title="title" @close="close" @cancel="cancelClick" @confirm="confirmClick">
            <div class="content">
                <div class="input-wrapper">
                    <span><strong>*</strong>{{ $t("zhiji.sensitiveWord.classifyName") }}：</span>
                    <input :placeholder="$t('zhiji.sensitiveWord.classifyNameTip')" v-model="className" />
                </div>
                <div class="input-wrapper">
                    <span><strong>*</strong>{{ $t("zhiji.common.language") }}：</span>
                    <LangSelect :value="initLang" class="lang-select" @change="langChange" :requireAll="true"></LangSelect>
                </div>
            </div>
        </TitleBaseBox>
    </div>
</template>

<script>
import TitleBaseBox from "@/views/zhiji/bComponents/TitleBaseBox";
import LangSelect from "@/components/langSelect";
import i18n from "@/i18n";

export default {
    name: "AddClassifyModal",
    props: ["data"],
    components: {
        TitleBaseBox,
        LangSelect
    },
    data() {
        return {
            className: "",
            initLang: "all"
        };
    },
    computed: {
        title() {
            return this.$t("zhiji.sensitiveWord.addClassifyLabel");
        }
    },
    methods: {
        cancelClick() {
            this.close();
        },
        confirmClick() {
            let checkedData = {
                groupName: this.className,
                lang: this.initLang
            };
            // eslint-disable-next-line
            this.checkData(checkedData) ? this.showErrorTips(this.checkData(checkedData))
                : this.saveGroupEdit();
        },
        saveGroupEdit() {
            this.$store.dispatch("zhiji/saveSensitiveGroup", {
                groupName: this.className,
                lang: this.initLang,
                status: "draft"
            });
            this.close();
        },
        langChange(data) {
            this.initLang = data;
        },
        close() {
            this.$emit("closeModal");
        },
        showErrorTips(errMessage) {
            this.$store.dispatch("zhiji/showModal", {
                type: "MessageModal",
                data: {
                    type: "error",
                    message: errMessage
                }
            });
        },
        checkData(data) {
            if (!data.groupName) {
                return i18n.t("zhiji.sensitiveWord.classifyNameTip");
            }

            if (data.lang === "all") {
                return i18n.t("zhiji.sensitiveWord.langSelect");
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.add-class-wrapper {
    height: 100%;
    width: 100%;
    background: rgba(65, 71, 94, 0.4);
    display: flex;
    align-items: center;
    justify-content: space-around;

    .input-wrapper {
        display: flex;
        align-items: center;
        position: relative;
        margin-bottom: 10px;
        span {
            width: 77px;
            display: inline-block;
        }
        input {
            width: 348px;
            padding: 7px 9px 7px;
            box-sizing: border-box;
            color: #41475e;
            border: 1px solid #d8e4f0;
            border-radius: 4px;
            padding-right: 35px;
            font-size: 12px;
        }
        .select-opt {
            width: 348px;
        }
        .error-tip {
            position: absolute;
            color: #fe0931;
            margin-top: 2px;
        }

        .input-delete-icon {
            position: absolute;
            right: 8px;
            top: 50%;
            margin-top: -9px;
        }
    }

    .content {
        padding: 20px 5px 0;
        margin-bottom: 12px;
        strong {
            color: red;
        }
    }
}
</style>
